import React from 'react'

function Privacy() {
  return (
    <>
    <section className="section">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="custom-module">
          <h1>
            <strong>Privacy Policy</strong>
          </h1>
          <p className="blogArticle">
            At enigmance.com, accessible from https://enigmance.com, one of our
            main priorities is the privacy of our visitors. This Privacy Policy
            document contains types of information that is collected and
            recorded by enigmance.com and how we use it.
          </p>
          <p className="blogArticle">
            If you have additional questions or require more information about
            our Privacy Policy, do not hesitate to contact us.
          </p>
          <p className="blogArticle">
            This Privacy Policy applies only to our online activities and is
            valid for visitors to our website with regards to the information
            that they shared and/or collect in enigmance.com. This policy is not
            applicable to any information collected offline or via channels
            other than this website.
          </p>
          <h2>
            <strong>Consent</strong>
          </h2>
          <p className="blogArticle">
            By using our website, you hereby consent to our Privacy Policy and
            agree to its terms.
          </p>
          <h2>
            <strong>Information we collect</strong>
          </h2>
          <p className="blogArticle">
            The personal information that you are asked to provide, and the
            reasons why you are asked to provide it, will be made clear to you
            at the point we ask you to provide your personal information.
          </p>
          <p className="blogArticle">
            If you contact us directly, we may receive additional information
            about you such as your name, email address, phone number, the
            contents of the message and/or attachments you may send us, and any
            other information you may choose to provide.
          </p>
          <p className="blogArticle">
            When you register for an Account, we may ask for your contact
            information, including items such as name, company name, address,
            email address, and telephone number.
          </p>
          <h2>
            <strong>How we use your information</strong>
          </h2>
          <p className="blogArticle">
            We use the information we collect in various ways, including to:
          </p>
          <p className="blogArticle"></p>
          <ul className="bloglist">
            <li>Provide, operate, and maintain our website</li>
            <li>Improve, personalize, and expand our website</li>
            <li>Understand and analyze how you use our website</li>
            <li>Develop new products, services, features, and functionality</li>
            <li>
              Communicate with you, either directly or through one of our
              partners, including for customer service, to provide you with
              updates and other information relating to the website, and for
              marketing and promotional purposes
            </li>
            <li>Send you emails</li>
            <li>Find and prevent fraud</li>
          </ul>
          <p />
          <h2>
            <strong>Log Files</strong>
          </h2>
          <p className="blogArticle">
            enigmance.com follows a standard procedure of using log files. These
            files log visitors when they visit websites. All hosting companies
            do this and a part of hosting services' analytics. The information
            collected by log files include internet protocol (IP) addresses,
            browser type, Internet Service Provider (ISP), date and time stamp,
            referring/exit pages, and possibly the number of clicks. These are
            not linked to any information that is personally identifiable. The
            purpose of the information is for analyzing trends, administering
            the site, tracking users' movement on the website, and gathering
            demographic information.
          </p>
          <h2>
            <strong>Cookies and Web Beacons</strong>
          </h2>
          <p className="blogArticle">
            Like any other website, enigmance.com uses 'cookies'. These cookies
            are used to store information including visitors' preferences, and
            the pages on the website that the visitor accessed or visited. The
            information is used to optimize the users' experience by customizing
            our web page content based on visitors' browser type and/or other
            information.
          </p>
          <h2>
            <strong>Our Advertising Partners</strong>
          </h2>
          <p className="blogArticle">
            Some of advertisers on our site may use cookies and web beacons. Our
            advertising partners are listed below. Each of our advertising
            partners has their own Privacy Policy for their policies on user
            data. For easier access, we hyperlinked to their Privacy Policies
            below.
          </p>
          <p className="blogArticle"></p>
          <ul className="bloglist">
            <li>
              <p className="blogArticle">Google</p>
              <p className="blogArticle">
                <a href="https://policies.google.com/technologies/ads">
                  https://policies.google.com/technologies/ads
                </a>
              </p>
            </li>
          </ul>
          <p />
          <h2>
            <strong>Our Advertising Partners Privacy Policies</strong>
          </h2>
          <p className="blogArticle">
            You may consult this list to find the Privacy Policy for each of the
            advertising partners of enigmance.com
          </p>
          <p className="blogArticle">
            Third-party ad servers or ad networks uses technologies like
            cookies, JavaScript, or Web Beacons that are used in their
            respective advertisements and links that appear on enigmance.com,
            which are sent directly to users' browser. They automatically
            receive your IP address when this occurs. These technologies are
            used to measure the effectiveness of their advertising campaigns
            and/or to personalize the advertising content that you see on
            websites that you visit.
          </p>
          <p className="blogArticle">
            Note that enigmance.com has no access to or control over these
            cookies that are used by third-party advertisers.
          </p>
          <h2>
            <strong>Third Party Privacy Policies</strong>
          </h2>
          <p className="blogArticle">
            enigmance.com's Privacy Policy does not apply to other advertisers
            or websites. Thus, we are advising you to consult the respective
            Privacy Policies of these third-party ad servers for more detailed
            information. It may include their practices and instructions about
            how to opt-out of certain options.
          </p>
          <p className="blogArticle">
            You can choose to disable cookies through your individual browser
            options. To know more detailed information about cookie management
            with specific web browsers, it can be found at the browsers'
            respective websites.
          </p>
          <h2>
            <strong>
              KDPA Data Privacy Act (Do Not Sell My Personal Information)
            </strong>
          </h2>
          <p className="blogArticle">
            Under the KDPA, among other rights, Kenyan consumers have the right
            to:
          </p>
          <p className="blogArticle">
            Request that a business that collects a consumer's personal data
            disclose the categories and specific pieces of personal data that a
            business has collected about consumers.
          </p>
          <p className="blogArticle">
            Request that a business delete any personal data about the consumer
            that a business has collected.
          </p>
          <p className="blogArticle">
            Request that a business that sells a consumer's personal data, not
            sell the consumer's personal data.
          </p>
          <p className="blogArticle">
            If you make a request, we have one month to respond to you. If you
            would like to exercise any of these rights, please contact us.
          </p>
          <h2>
            <strong>GDPR Data Protection Rights</strong>
          </h2>
          <p className="blogArticle">
            We would like to make sure you are fully aware of all of your data
            protection rights. Every user is entitled to the following:
          </p>
          <p className="blogArticle">
            The right to access – You have the right to request copies of your
            personal data. We may charge you a small fee for this service.
          </p>
          <p className="blogArticle">
            The right to rectification – You have the right to request that we
            correct any information you believe is inaccurate. You also have the
            right to request that we complete the information you believe is
            incomplete.
          </p>
          <p className="blogArticle">
            The right to erasure – You have the right to request that we erase
            your personal data, under certain conditions.
          </p>
          <p className="blogArticle">
            The right to restrict processing – You have the right to request
            that we restrict the processing of your personal data, under certain
            conditions.{" "}
          </p>
          <p className="blogArticle">
            The right to object to processing – You have the right to object to
            our processing of your personal data, under certain conditions.{" "}
          </p>
          <p className="blogArticle">
            The right to data portability – You have the right to request that
            we transfer the data that we have collected to another organization,
            or directly to you, under certain conditions.
          </p>
          <p className="blogArticle">
            If you make a request, we have one month to respond to you. If you
            would like to exercise any of these rights, please contact us.
          </p>
          <h2>
            <strong>Children's Information</strong>
          </h2>
          <p className="blogArticle">
            Another part of our priority is adding protection for children while
            using the internet. We encourage parents and guardians to observe,
            participate in, and/or monitor and guide their online activity.
          </p>
          <p className="blogArticle">
            enigmance.com does not knowingly collect any Personal Identifiable
            Information from children under the age of 13. If you think that
            your child provided this kind of information on our website, we
            strongly encourage you to contact us immediately and we will do our
            best efforts to promptly remove such information from our records.
          </p>
        </div>
        {/* end custom-module */}
      </div>
      {/* end col */}
    </div>
    {/* end row */}
  </div>
  {/* end container */}
</section>

    </>
  )
}

export default Privacy